import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={29} height={30.93} {...props}>
      <defs>
        <style>{`.prefix__cls-1{fill:${props.fillPrimary}}`}</style>
      </defs>
      <g id="prefix__Group_2491" data-name="Group 2491" transform="translate(-228 -470.069)">
        <g id="prefix__Group_2488" data-name="Group 2488" transform="translate(0 208)">
          <g id="prefix__Group_2481" data-name="Group 2481" transform="translate(0 78)">
            <rect
              id="prefix__Rectangle_918"
              data-name="Rectangle 918"
              className="prefix__cls-1"
              width={29}
              height={11}
              rx={5.5}
              transform="translate(228 203)"
            />
          </g>
        </g>
        <g id="prefix__Group_2489" data-name="Group 2489">
          <g id="prefix__Group_1616" data-name="Group 1616" transform="translate(234.163 470.069)">
            <g id="prefix__Group_1613" data-name="Group 1613">
              <path
                id="prefix__Path_5335"
                data-name="Path 5335"
                className="prefix__cls-1"
                d="M248.185 217.674c-.338.266-.655.523-.983.765a.326.326 0 01-.249.019 10.251 10.251 0 01-7.464-7.767 10.014 10.014 0 01.4-6.011.594.594 0 01.482-.442c.176-.033.348-.091.538-.142a2.5 2.5 0 00-.015.263.471.471 0 00.365.456.46.46 0 00.528-.19.751.751 0 00.134-.267c.092-.387.338-.49.716-.48a8.643 8.643 0 012.855.526 7.6 7.6 0 014.538 4.344 7.782 7.782 0 01-.9 7.822.29.29 0 01-.358.153 2.66 2.66 0 00-.458-.071.5.5 0 00-.268.953zm-4.185-3.09a1.764 1.764 0 00-.157-.35q-.584-.738-1.186-1.463a.484.484 0 00-.643-.095.462.462 0 00-.164.645c.412.543.84 1.075 1.3 1.578a.592.592 0 00.52.059c.136-.051.222-.248.33-.374zm-3.05-5.326c-.347 0-.608.25-.531.549.167.647.367 1.288.587 1.919a.449.449 0 00.621.227.487.487 0 00.276-.606q-.255-.859-.518-1.716a.468.468 0 00-.438-.373zm-.74-1.8h.022a4.443 4.443 0 000 .518.467.467 0 00.7.356.587.587 0 00.293-.546c.034-.5.073-1 .129-1.493.044-.388-.086-.642-.39-.69s-.538.143-.594.527c-.07.447-.111.89-.163 1.332zm6.757 9.027c-.051-.068-.124-.243-.254-.321-.522-.311-1.06-.6-1.6-.88a.48.48 0 00-.643.18.451.451 0 00.111.633c.569.337 1.149.66 1.744.947.299.148.639-.125.638-.555z"
                transform="translate(-234.736 -203.879)"
              />
              <path
                id="prefix__Path_5336"
                data-name="Path 5336"
                className="prefix__cls-1"
                d="M162.289 225.586c.508.241.771.107.893-.442a1.67 1.67 0 011.214-1.3 11.469 11.469 0 007.076 14.146l.013.088c-.549.15-1.094.33-1.652.432-.169.031-.381-.144-.567-.238-.548-.279-.762-.2-.957.374a7.94 7.94 0 01-6.021-13.064zm-.377 2.459h-.032c.068.587.122 1.175.208 1.759a.46.46 0 00.545.379.492.492 0 00.426-.518q-.072-1.115-.158-2.23a.493.493 0 00-.986.006c-.015.203-.003.404-.003.604zm1.333 3.346c-.471-.006-.722.335-.573.685.3.7.622 1.392.956 2.077a.479.479 0 00.677.2.49.49 0 00.2-.661c-.306-.668-.6-1.341-.932-2-.073-.145-.26-.239-.328-.301zm4.269 5.984a1.768 1.768 0 00-.207-.381c-.525-.53-1.058-1.051-1.592-1.571a.483.483 0 00-.688-.023.463.463 0 00-.054.663 37.684 37.684 0 001.717 1.675.567.567 0 00.5.027c.138-.065.217-.252.325-.39z"
                transform="translate(-160.412 -222.715)"
              />
            </g>
          </g>
          <text
            id="prefix__BOW"
            transform="translate(243 498)"
            fill={props.fillSecondary}
            fontSize={10}
            fontFamily="ProximaNova-Bold,Proxima Nova"
            fontWeight={700}>
            <tspan x={-11.63} y={0}>
              {'BOW'}
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
